import React, {Component} from 'react';
import withAuth from './withAuth';
import Menu from "./Menu";
import '../styles/Connect.css';
import { Route, Switch } from "react-router-dom";
import Website from "./Website";
import Threads from "./Threads";
import User from "./User";
import Comment from "./Comment";
import Debate from "./Debate";
import Deletewebsite from "./Deletewebsite";
import Data from "./Data";
import Formpub from "./Formpub";
import FormVip from "./FormVip";
import Formnews from "./Formnews";
import Listenews from "./Listenews";
import Listlicence from "./Listlicence";
import ListVip from "./ListVip";
import Formlicence from "./Formlicence";
import Views from "./Views";
import Bills from "./Bills";
import Commentaires from "./Commentaires";
import StatViews  from "./StatViews";
import  Pagesgd from "./Pagesgd";
import  Redirection from "./Redirection";
import { Grid, Box, Button, Typography } from '@mui/material';

// les routes
class connect extends Component {
  constructor(props) {
    super(props);
    this.handleDeconnectClick = this.handleDeconnectClick.bind(this);
    this.handleLogout = this.handleLogout.bind(this)
  }

  handleLogout() {
    this.props.history.replace('/App');
  }

  handleDeconnectClick() {
    localStorage.removeItem('gc_token');
    window.location.reload();
  }

  render() {
    return (
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={2}>
            <Box sx={{ p: 2 }}>
              <Menu />
              <Box sx={{ mt: 2 }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={this.handleDeconnectClick}
                >
                  Disconnection
                </Button>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={10}>
            <Switch>
              <Route exact path="/super-admin/" component={withAuth(Data)}/>
              <Route exact path="/super-admin/website" component={withAuth(Website)}/>
              <Route exact path="/super-admin/website/delete" component={withAuth(Deletewebsite)}/>
              <Route path="/super-admin/thread" component={withAuth(Threads)}/>
              <Route path="/super-admin/Formpub" component={withAuth(Formpub)}/>
              <Route path="/super-admin/FormVip" component={withAuth(FormVip)}/>
              <Route path="/super-admin/user" component={withAuth(User)}/>
              <Route exact path="/super-admin/website/:website_id/comment" component={withAuth(Comment)}/>
              <Route exact path="/super-admin/website/:website_id/debate" component={withAuth(Debate)}/>
              <Route path="/super-admin/Formnews" component={withAuth(Formnews)}/>
              <Route path="/super-admin/Listenews" component={withAuth(Listenews)}/>
              <Route path="/super-admin/Listlicence" component={withAuth(Listlicence)}/>
              <Route path="/super-admin/ListVip" component={withAuth(ListVip)}/>
              <Route path="/super-admin/Formlicence" component={withAuth(Formlicence)}/>
              <Route path="/super-admin/Views" component={withAuth(Views)}/>
              <Route path="/super-admin/Bills" component={withAuth(Bills)}/>
              <Route path="/super-admin/Commentaires" component={withAuth(Commentaires)}/>
              <Route path="/super-admin/StatViews" component={withAuth(StatViews)}/>
              <Route path="/super-admin/Pagesgd" component={withAuth(Pagesgd)}/>
              <Route path="/super-admin/Redirection" component={withAuth(Redirection)}/>
            </Switch>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ bgcolor: 'grey.900', color: 'common.white', p: 2, textAlign: 'center' }}>
              <Typography variant="body2">Copyright ©2019 Super-admin Semiologic</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };
}

export default connect;